import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/202502/notice.png';
import _imports_1 from '@/assets/img/202502/right.png';
const _withScopeId = n => (_pushScopeId("data-v-25a98f08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "HomeView"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "notice box flex-row-align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-size",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "notice-content"
};
const _hoisted_6 = {
  class: "meaus-innerBox"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-size",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_12 = {
  class: "right"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "240px",
    "font-size": "17px",
    "color": "#000000"
  }
}, " 请选择充值方式 ", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "10px"
  }
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "15px"
  }
}, "(￥1000-5000)", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "15px"
  }
}, "(金额不限)", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "15px"
  }
}, "(￥39800)", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "15px"
  }
}, "(￥79800)", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_swipe, {
    class: "my-swipe",
    autoplay: 3000,
    "indicator-color": "white"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banner, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        ket: index
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "img box",
          src: _ctx.getImg(item.content),
          alt: ""
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1032, ["ket"]);
    }), 256))]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_notice_bar, {
    scrollable: "",
    speed: 30,
    background: "#fff",
    text: _ctx.marquee_placard[this.$i18n.locale]
  }, null, 8, ["text"])])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allMeaus, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "box",
      key: item.path,
      onClick: $event => _ctx.toServis(item.path)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.desc), 1), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
      class: "img-size",
      src: item.ico,
      alt: ""
    }, null, 8, _hoisted_13)])], 8, _hoisted_7);
  }), 128))]), _createVNode(_component_van_popup, {
    closeable: "",
    show: _ctx.chongzhi_flag,
    round: "",
    style: {
      padding: '20px'
    },
    onClose: _cache[4] || (_cache[4] = $event => _ctx.chongzhi_flag = false)
  }, {
    default: _withCtx(() => [_hoisted_14, _hoisted_15, _ctx.myInfo.is_first_recharge ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.gorecharge(4)),
      style: {
        "margin-top": "20px",
        "font-size": "17px"
      },
      class: "",
      type: "success",
      block: ""
    }, {
      default: _withCtx(() => [_createTextVNode(" U商代充(限首充) "), _hoisted_16]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_van_button, {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.gorecharge(1)),
      style: {
        "margin-top": "20px",
        "font-size": "17px"
      },
      class: "",
      type: "success",
      block: ""
    }, {
      default: _withCtx(() => [_createTextVNode(" 普通充值 "), _hoisted_17]),
      _: 1
    }), _createVNode(_component_van_button, {
      onClick: _cache[2] || (_cache[2] = $event => _ctx.gorecharge(2)),
      style: {
        "margin-top": "20px",
        "font-size": "17px",
        "background-color": "#a200ff"
      },
      class: "",
      type: "success",
      block: ""
    }, {
      default: _withCtx(() => [_createTextVNode(" 代理人充值 "), _hoisted_18]),
      _: 1
    }), _createVNode(_component_van_button, {
      onClick: _cache[3] || (_cache[3] = $event => _ctx.gorecharge(3)),
      style: {
        "margin-top": "20px",
        "font-size": "17px",
        "background-color": "#000"
      },
      class: "",
      type: "success",
      block: ""
    }, {
      default: _withCtx(() => [_createTextVNode(" 区域总监充值 "), _hoisted_19]),
      _: 1
    })]),
    _: 1
  }, 8, ["show"])]);
}